import src from "IMAGE";
export default { src, width: 212, height: 52, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AEB3bL44NQxGGBkaKhUWFyYXGBkpGBkaKxscHTMVFhcmAH9UYb5FLQlFExMUIRobHS8kJihCHB0eMBUWFyYeICE3kHcLG/fedRwAAAAASUVORK5CYII="};
